import { useQuery } from '@tanstack/react-query'
import { CoatController } from 'src/controllers/coat.controller'
import { CoatDto } from 'src/dto/coat.dto'

const coatController = new CoatController()

export function useGetCoatList() {
  return useQuery<CoatDto[], Error>({
    queryKey: ['getCoatList'],
    queryFn: () => coatController.getCoatList()
  })
}
